export default {
  hasScreenshareAccess: (state) => {
    return state.isScreenshareSupported && state.hasScreensharePermissions;
  }
};
